import { render, staticRenderFns } from "./ActivationBriefShippingView.vue?vue&type=template&id=9aebf47c&"
import script from "./ActivationBriefShippingView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefShippingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports